import React from "react";

export default function Referrals() {
  return <div>Referrals</div>;
}
